/*
 * Created Date: 17-01-2024, 10:02:23 am
 * Author: Victor
 * Email: victor@pt-corp.vn
 * -----
 * Last Modified:
 * Modified By:
 * -----
 * Copyright (c) 2024 PT CORP, Inc
 * -----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	----------------------------------------------------------
 */

export const SOCIAL_AUTH_CLIENT = {
	google_client_id:
		// import.meta.env.VITE_GOOGLE_AUTH_CLIENT_ID ??
		'757038299974-bjqk49ii79p127vheo63j3e8sdvv4jrs.apps.googleusercontent.com'
}
export const CRM_BE_URL = import.meta.env.VITE_CRM_BE_URL ?? 'https://crm-dev.eduquiz.vn'
export const STUDIO_BE_URL = import.meta.env.VITE_STUDIO_BE_URL ?? 'https://studio-dev.103-170-122-18.flashvps.xyz' //  'https://api-studio-uat.eduquiz.io.vn' //
export const PUSHSER_KEY = import.meta.env.VITE_PUSHER_KEY ?? '6b25fb092359e476a45b'
export const TYPESENSE_URL = import.meta.env.VITE_TYPESENSE_URL ?? 'typesense.eduquiz.vn'
export const TYPESENSE_SEARCH_KEY =
	import.meta.env.VITE_TYPESENSE_SEARCH_KEY ?? 'rbs7jxSfxvhumLWiEXRqw3ZDpmSXLjMDlwX7DvcHBk3Dgr8r'
export const EDUQUIZ_APP = import.meta.env.VITE_EDUQUIZ_APP ?? 'https://eduquiz.vn'
export const QUIZ_BE_API_URL = import.meta.env.VITE_QUIZ_BE_API_URL ?? 'https://quiz-api-01.eduquiz.io.vn'
